import { push } from 'connected-react-router'
import { all, call, put, select, take, takeEvery } from 'redux-saga/effects'
import { t } from 'ttag'
import { getWhoAmI, getWhoAmIFail, getWhoAmISuccess } from '../../../common/auth/authActions'
import { INotification } from '../../../common/notifications/NotificationReducers'
import { ROUTES } from '../../../common/Routes/routePaths'
import api from '../../../services/api.services'
import {
  registerAppleHealth,
  registerUser,
  registerUserSuccess,
  registerWithoutIntegration,
  setOnboardingStatusToActivityData,
  setOnboardingStatusToIntegration,
  updateActivityData,
} from './RegisterUserActions'
import { clearNotification } from '../../../common/notifications/NotificationActions'
import { initialAppleHealthIntegration, setIntegrationSuccess } from '../../../common/integration/integrationActions'
import { Preferences } from '@capacitor/preferences'

function* sagaRegisterUser({ payload }: any) {
  try {
    const { password, firstName, lastName, divisionId, country, timeZone, newsletterSubscriber } = payload
    yield put({ type: String(clearNotification) })
    yield call(api.activity.updateProfileData, {
      firstName,
      lastName,
      divisionId,
      country,
      timeZone,
      newsletterSubscriber,
    })
    yield call(api.auth.registerUser, { password })
    yield put({ type: String(registerUserSuccess) })

    // Update userDto...
    yield put({ type: String(getWhoAmI) })
    yield take([String(getWhoAmISuccess), String(getWhoAmIFail)])
  } catch (e: any) {
    console.error('RegisterUserFailed: ', e)
  }
}

function* sagaUpdateActivityData({ payload }: any) {
  try {
    const { dateOfBirth, gender, height, weight, units } = payload
    yield put({ type: String(clearNotification) })
    yield call(api.activity.updateActivityData, {
      dateOfBirth,
      gender,
      units,
      height,
      weight,
    })

    // Update userDto...
    yield put({ type: String(getWhoAmI) })
    yield take([String(getWhoAmISuccess), String(getWhoAmIFail)])
  } catch (e: any) {
    console.error('RegisterUserFailed: ', e)
  }
}

function* sagaRegisterAppleHealthUser({ payload }: any) {
  try {
    yield put({ type: String(clearNotification) })
    if (payload && payload.password) {
      const { password } = payload
      yield call(api.auth.registerUser, { password })
      yield Preferences.remove({ key: 'isAppleHealthIntegration' })
      window.location.reload()
    } else {
      yield call(api.activity.setAppleHealthIntegration)
      yield Preferences.remove({ key: 'isAppleHealthIntegration' })
      yield put({ type: String(getWhoAmI) })
      yield take([String(getWhoAmISuccess), String(getWhoAmIFail)])
      yield put({ type: String(setIntegrationSuccess) })
      yield put({ type: String(initialAppleHealthIntegration) })
    }
  } catch (e: any) {
    console.error('RegisterUserFailed: ', e)
  }
}

function* sagaRegisterWithoutIntegration() {
  try {
    yield put({ type: String(clearNotification) })
    yield call(api.activity.setNoIntegration)

    // Update userDto...
    yield put({ type: String(getWhoAmI) })
    yield take([String(getWhoAmISuccess), String(getWhoAmIFail)])
    yield put(push(ROUTES.CLIENT_ACTIVITY.to))
  } catch (e: any) {
    console.error('RegisterWithoutIntegration failed: ', e)
  }
}

function* sagaSetOnboardingStatusToActivityData() {
  try {
    yield put({ type: String(clearNotification) })
    yield call(api.activity.setOnboardingStatusToActivityData)
    yield put({ type: String(getWhoAmI) })
    // Make sure whoAmI is finished, before we proceed.
    yield take([String(getWhoAmISuccess), String(getWhoAmIFail)])
    yield put(push(ROUTES.REGISTER_USER.to))
  } catch (e: any) {
    console.error('SetOnboardingStatusToActivityData failed: ', e)
  }
}

function* sagaSetOnboardingStatusToIntegration() {
  try {
    yield put({ type: String(clearNotification) })
    yield call(api.activity.setOnboardingStatusToIntegration)
    yield put({ type: String(getWhoAmI) })
    // Make sure whoAmI is finished, before we proceed.
    yield take([String(getWhoAmISuccess), String(getWhoAmIFail)])
    yield put(push(ROUTES.REGISTER_USER.to))
  } catch (e: any) {
    console.error('SetOnboardingStatusToIntegration failed: ', e)
  }
}

export function* registerUserSagas() {
  yield all([
    takeEvery(String(registerUser), sagaRegisterUser),
    takeEvery(String(registerAppleHealth), sagaRegisterAppleHealthUser),
    takeEvery(String(registerWithoutIntegration), sagaRegisterWithoutIntegration),
    takeEvery(String(setOnboardingStatusToActivityData), sagaSetOnboardingStatusToActivityData),
    takeEvery(String(setOnboardingStatusToIntegration), sagaSetOnboardingStatusToIntegration),
    takeEvery(String(updateActivityData), sagaUpdateActivityData),
  ])
}
